<!--
	Slider — single-thumb `<input type="range">` with evenly-spaced labels
	beneath the track. `value` is bindable.
-->
<script lang="ts">
	interface Props {
		/** Current value (bindable). */
		value: number;
		min: number;
		max: number;
		/** Labels evenly spaced along the track — provide values to match. */
		labels: string[];
		/** Accessible name; the track labels only describe the ends. */
		'aria-label': string;
	}

	let { value = $bindable(), min, max, labels, 'aria-label': ariaLabel }: Props = $props();
</script>

<div class="container">
	<input class="singleSliderInput" type="range" {min} {max} bind:value aria-label={ariaLabel} />
	<ul class="rangeLabels">
		{#each labels as label, i (i)}
			<li>{label}</li>
		{/each}
	</ul>
</div>

<style>
	.container {
		width: 100%;
	}

	/* Native track and thumb, tinted to the brand; keeps the browser's own focus ring. */
	.singleSliderInput {
		accent-color: var(--accent);
		width: 100%;
	}

	.rangeLabels {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0;
		font-size: var(--font-size-sm);
		list-style: none;

		li {
			display: flex;
			width: 0;
			white-space: nowrap;
		}

		li:not(:first-child):not(:last-child) {
			justify-content: center;
		}

		li:last-child {
			justify-content: end;
		}
	}
</style>
